import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: "Homemowner's Insurance Valuation" },
	{
		name: 'description',
		content:
			"The options you have to choose from are often referred to as 'replacement cost' and 'actual cash value'.",
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Homeowner's Insurance Valuation
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you purchase homeowner's insurance, you have some options when it
				comes to choosing how you want your policy to respond when you file a
				claim. One of the options you have is choosing how your home and
				contents will be valued at the time of the loss. The options you have to
				choose from are often referred to as "replacement cost" and "actual cash
				value". You should choose the option that best suits your individual
				circumstances. Here is a brief explanation:
			</p>
			<h2 className="p-4 text-2xl font-semibold">Replacement Cost</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you choose to purchase a replacement cost policy, you're choosing
				to insure your home for the full cost it would take you to rebuild your
				home with the same construction in the same location. With construction
				costs changing over time, you should evaluate the limit you carry on
				your policy periodically to make sure you have the right amount of
				coverage. Most policies also have an inflationary adjustment that is
				made every year that increases the coverage by a small percentage in
				order to keep up with inflation. Many people assume that they need to
				insure their home for the amount that they could get for it if they were
				to sell it on the real estate market. Often the market value and the
				replacement cost are two very different numbers.
			</p>
			<h2 className="p-4 text-2xl font-semibold">Actual Cash Value</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				This valuation method calculates the value of your home with
				depreciation for age and condition of your home. This type of policy is
				generally less desirable and often more expensive than a replacement
				cost policy. However, for certain circumstances it may make better sense
				or be the only available option.
			</p>
			<h2 className="p-4 text-2xl font-semibold">A Startling Fact</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In 2007, 66 percent of homeowners in the U.S. were <em>under</em>insured
				(by an average of 18 percent). When there is a total loss, meaning that
				the home is completely destroyed, a homeowner will not get enough
				insurance reimbursement to replace their home if they do not carry a
				high enough limit. For this reason, it's important to insure your home
				to its full replacement value (for a replacement cost policy). When you
				make changes to your home, make sure that you adjust the limit of
				insurance accordingly. Renovations such as building a garage or porch,
				adding an addition, or remodeling a kitchen or bathroom can add a
				measurable amount to the replacement cost of your home.
			</p>
		</>
	)
}
